import { render } from "./KskCartModifiers.vue?vue&type=template&id=41be8c5f&scoped=true"
import script from "./KskCartModifiers.vue?vue&type=script&lang=js"
export * from "./KskCartModifiers.vue?vue&type=script&lang=js"

import "./KskCartModifiers.vue?vue&type=style&index=0&id=41be8c5f&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41be8c5f"]])

export default __exports__